import {Checkbox, Col, Row, Space, Table, Typography} from "antd";
import React, {Fragment, useEffect, useState} from "react";
import {columns} from "../../../NurseOutModal/config";
import {checkEmptyObjVitalSigns, renderViTriMat} from "helper/nurseOut";
import Notification from "components/common/notification/notification";
import {catalogService} from "api";
import {useAppSelector} from "redux/hooks";
import {HeaderCustom} from "components/common";
import VitalSigns from "components/common/PrintReceipt/component/VitalSigns/VitalSigns";
import SearchPatientService from "api/searchPatient";

const syringingInfo = syringingInfo => {
  return [
    {label: "Lệ đạo trên", value: syringingInfo?.LowerPunctum},
    {label: "Lệ đạo dưới", value: syringingInfo?.UpperPunctum},
    {label: "Ghi chú", value: syringingInfo?.Comment},
  ];
};
type NurseExamPrintProps = {
  jsonData: any;
  tienSuBenh: any;
  nhanAp: any;
  leDao: any;
  traThuoc: boolean;
  duongHuyet: boolean;
  thongTinDieuDuong: boolean;
  handleCheckboxChange?: (e, type) => void;
};

const NurseExamPrintOut = ({
  jsonData,
  tienSuBenh,
  nhanAp,
  leDao,
  traThuoc,
  duongHuyet,
  thongTinDieuDuong,
  handleCheckboxChange,
}: NurseExamPrintProps) => {
  const idPhieu = useAppSelector(state => state.examination.idReceipt);

  useEffect(() => {
    if (idPhieu != null) {
      getListLichsuTraThuoc(idPhieu);
    }
  }, [idPhieu]);
  const getListLichsuTraThuoc = async idPhieu => {
    try {
      const res = await SearchPatientService.getListLichsuTraThuoc(idPhieu);
      setLichSuTra(res);
    } catch (error) {
      // Notification(
      //   "error",
      //   "Đã có lỗi khi lấy thông tin lịch sử tra thuốc của phiếu"
      // );
    }
  };
  useEffect(() => {
    if (jsonData) {
      parseJsonValueToObject(jsonData);
    }
  }, [jsonData]);
  const [dataTable, setDataTable] = useState<any[]>([
    {benhSu: "Bệnh sử", ghiChu: ""},
    {benhSu: "Tiền sử bệnh nhãn khoa", ghiChu: ""},
    {benhSu: "Tiền sử bệnh toàn thân", ghiChu: ""},
    {benhSu: "Tiền sử dị ứng thuốc", ghiChu: ""},
    {benhSu: "Tiền sử dị ứng thực phẩm", ghiChu: ""},
  ]);
  const [lichSuTra, setLichSuTra] = useState<any[]>([]);

  const [dataNurse, setDataNurse] = useState<any>();

  const parseJsonValueToObject = dataJson => {
    const data = {
      ...dataJson,
      chiefComplaints: JSON.parse(dataJson?.chiefComplaints),
      contactAllergies: JSON.parse(dataJson?.contactAllergies),
      intraocularPressure: JSON.parse(dataJson?.intraocularPressure) || {
        ["intraocularPressureRight"]: null,
        ["intraocularPressureLeft"]: null,
      },
      ophthalmicHistory: JSON.parse(dataJson?.ophthalmicHistory),
      drugAllergies: JSON.parse(dataJson?.drugAllergies),
      foodAllergies: JSON.parse(dataJson?.foodAllergies),
      systemicHistory: JSON.parse(dataJson?.systemicHistory),
      vitalSigns: JSON.parse(dataJson?.vitalSigns),
      syringing: JSON.parse(dataJson?.syringing),
      randomBloodSugar: JSON.parse(dataJson?.randomBloodSugar),
    };
    let dataTable = [];

    if (data?.chiefComplaints?.Comments) {
      dataTable.push({
        benhSu: "Bệnh sử",
        ghiChu: data?.chiefComplaints?.Comments,
      });
    }
    if (data?.ophthalmicHistory?.Comments) {
      dataTable.push({
        benhSu: "Tiền sử bệnh nhãn khoa",
        ghiChu: data?.ophthalmicHistory?.Comments,
      });
    }
    if (data?.systemicHistory?.Comments) {
      dataTable.push({
        benhSu: "Tiền sử bệnh toàn thân",
        ghiChu: data?.systemicHistory?.Comments,
      });
    }
    if (data?.systemicHistory?.FamilyHistory) {
      dataTable.push({
        benhSu: "Tiền sử gia đình",
        ghiChu: data?.systemicHistory?.FamilyHistory,
      });
    }
    if (data?.systemicHistory?.MedicalHistory) {
      dataTable.push({
        benhSu: "Tiền sử bệnh",
        ghiChu: data?.systemicHistory?.MedicalHistory,
      });
    }
    if (data?.contactAllergies?.DrugAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng thuốc",
        ghiChu: data?.contactAllergies?.DrugAllergiesComment,
      });
    }
    if (data?.contactAllergies?.ContactAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng tiếp xúc",
        ghiChu: data?.contactAllergies?.ContactAllergiesComment,
      });
    }
    if (data?.contactAllergies?.FoodAllergiesComment) {
      dataTable.push({
        benhSu: "Tiền sử dị ứng thực phẩm",
        ghiChu: data?.contactAllergies?.FoodAllergiesComment,
      });
    }
    if (data?.foodAllergies?.Comment) {
      dataTable.push({
        benhSu: "Ghi chú khác",
        ghiChu: data?.foodAllergies?.Comment,
      });
    }
    setDataTable([...dataTable]);
    setDataNurse({
      vitalSigns: data?.vitalSigns,
      intraocularPressure: data?.intraocularPressure,
      syringing: data?.syringing,
      randomBloodSugar: data?.randomBloodSugar,
    });
  };
  return (
    <Fragment>
      {dataTable.length > 0 && tienSuBenh && (
        <div className="container2" style={{marginBottom: 8, width: "100%"}}>
          <Row align={"middle"} gutter={4}>
            <Typography.Text
              style={{
                fontWeight: "700",
                fontSize: 22,

                marginBottom: 8,
              }}
            >
              Tiền sử bệnh
            </Typography.Text>
          </Row>

          <Table
            className="table-print"
            columns={columns}
            dataSource={dataTable}
            pagination={false}
            bordered
          ></Table>
        </div>
      )}
      {/* Thông tin điều dưỡng */}
      {!checkEmptyObjVitalSigns(dataNurse?.vitalSigns) && thongTinDieuDuong && (
        <div className="container2" style={{marginBottom: 8, width: "100%"}}>
          <Row align={"middle"} gutter={4}>
            <Typography.Text
              style={{
                fontWeight: "700",
                fontSize: 20,

                marginBottom: 8,
              }}
            >
              Thông tin điều dưỡng
            </Typography.Text>
          </Row>
          <VitalSigns data={dataNurse.vitalSigns}></VitalSigns>
        </div>
      )}
      {dataNurse &&
        nhanAp &&
        (dataNurse?.intraocularPressure['"intraocularPressureRight"'] ||
          dataNurse?.intraocularPressure['"intraocularPressureLeft"']) && (
          <div className="container4" style={{marginBottom: 8, width: "100%"}}>
            <Row align={"middle"} gutter={4}>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,

                  marginBottom: 8,
                }}
              >
                Nhãn áp
              </Typography.Text>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <HeaderCustom title="Mắt phải"></HeaderCustom>

                <Row gutter={[8, 8]}>
                  {dataNurse?.intraocularPressure[
                    '"intraocularPressureLeft"'
                  ]?.map((e, index) => (
                    <>
                      {e?.mmHg && (
                        <Row gutter={[4, 4]}>
                          <Col span={12}>
                            <Row>
                              <span style={{fontWeight: "600", marginRight: 4}}>
                                Kết quả:
                              </span>{" "}
                              {e?.mmHg} mmHG
                            </Row>
                          </Col>{" "}
                          {e?.method && (
                            <Col span={12}>
                              <Row>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    marginRight: 4,
                                  }}
                                >
                                  Phương pháp:
                                </span>{" "}
                                {e?.method ?? "--"}
                              </Row>
                            </Col>
                          )}
                          {e?.comment && (
                            <Col span={24}>
                              <Row>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    marginRight: 4,
                                  }}
                                >
                                  Ghi chú:
                                </span>{" "}
                                {e?.comment ?? "--"}
                              </Row>
                            </Col>
                          )}
                        </Row>
                      )}
                    </>
                  ))}
                </Row>
              </Col>
              <Col span={12}>
                <HeaderCustom title="Mắt trái"></HeaderCustom>
                {dataNurse && (
                  <Row gutter={[8, 8]}>
                    {dataNurse?.intraocularPressure[
                      '"intraocularPressureRight"'
                    ]?.map((e, index) => (
                      <>
                        {e?.mmHg && (
                          <Row gutter={[4, 4]}>
                            <Col span={12}>
                              <Row>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    marginRight: 4,
                                  }}
                                >
                                  Kết quả:
                                </span>{" "}
                                {e?.mmHg ?? "--"} mmHg
                              </Row>
                            </Col>{" "}
                            {e?.method && (
                              <Col span={12}>
                                <Row>
                                  <span
                                    style={{
                                      fontWeight: "600",
                                      marginRight: 4,
                                    }}
                                  >
                                    Phương pháp:
                                  </span>{" "}
                                  {e?.method ?? "--"}
                                </Row>
                              </Col>
                            )}
                            {e?.comment && (
                              <Col span={24}>
                                <Row>
                                  <span
                                    style={{
                                      fontWeight: "600",
                                      marginRight: 4,
                                    }}
                                  >
                                    Ghi chú:
                                  </span>{" "}
                                  {e?.comment ?? "--"}
                                </Row>
                              </Col>
                            )}
                          </Row>
                        )}
                      </>
                    ))}
                  </Row>
                )}
              </Col>
            </Row>
          </div>
        )}
      {dataNurse &&
        leDao &&
        dataNurse?.syringing &&
        (syringingInfo(dataNurse.syringing?.L)?.findIndex(e => e?.value) !=
          -1 ||
          syringingInfo(dataNurse.syringing?.R)?.findIndex(e => e?.value) !=
            -1) && (
          <div className="container5" style={{marginBottom: 8, width: "100%"}}>
            <Row align={"middle"} gutter={4}>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,

                  marginBottom: 8,
                }}
              >
                Lệ đạo
              </Typography.Text>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={12}>
                <HeaderCustom title="Mắt phải"></HeaderCustom>

                <>
                  {syringingInfo(dataNurse.syringing?.L).map(e => (
                    <>
                      {e?.value && (
                        <Row>
                          <span style={{fontWeight: "600", marginRight: 4}}>
                            {`${e.label}:`}{" "}
                          </span>{" "}
                          {e.value}
                        </Row>
                      )}
                    </>
                  ))}
                </>
              </Col>
              <Col span={12}>
                <HeaderCustom title="Mắt trái"></HeaderCustom>
                <>
                  {syringingInfo(dataNurse.syringing?.R).map(e => (
                    <>
                      {e?.value && (
                        <Row>
                          <span style={{fontWeight: "600", marginRight: 4}}>
                            {`${e.label}:`}{" "}
                          </span>{" "}
                          {e.value ?? "--"}
                        </Row>
                      )}
                    </>
                  ))}
                </>
              </Col>
            </Row>
          </div>
        )}
      {dataNurse &&
        dataNurse?.randomBloodSugar &&
        dataNurse.randomBloodSugar?.Result?.findIndex(e => e?.mmHg) != -1 && (
          <div className="container5" style={{marginBottom: 8, width: "100%"}}>
            <Row align={"middle"} gutter={4} style={{width: "100%"}}>
              <Col>
                <Typography.Text
                  style={{
                    fontWeight: "700",
                    fontSize: 22,

                    marginBottom: 8,
                  }}
                >
                  Đường huyết
                </Typography.Text>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{width: "100%"}}>
              <>
                {(dataNurse.randomBloodSugar?.Result).map(e => (
                  <>
                    {e?.mmHg && (
                      <Space style={{width: "100%"}}>
                        <div>
                          <span style={{fontWeight: "600", marginRight: 4}}>
                            {"Kết quả :"}{" "}
                          </span>{" "}
                          {e.mmHg} mmol/L
                        </div>
                        <div>
                          <span style={{fontWeight: "600", marginRight: 4}}>
                            {"Ghi chú :"}{" "}
                          </span>{" "}
                          {e?.comment}
                        </div>
                      </Space>
                    )}
                  </>
                ))}
              </>
            </Row>
          </div>
        )}
      {/* Tra thuốc */}
      {traThuoc && lichSuTra.length > 0 && (
        <div className="container7" style={{marginBottom: 8}}>
          <Row align={"middle"} gutter={4}>
            <Typography.Text
              style={{
                fontWeight: "700",
                fontSize: 20,

                marginBottom: 8,
              }}
            >
              Tra thuốc
            </Typography.Text>
          </Row>
          <Row gutter={[8, 8]}>
            {lichSuTra.map(e => (
              <Row gutter={[8, 8]}>
                <Col span={8}>
                  <Row>
                    <span style={{fontWeight: "600", marginRight: 4}}>
                      Loại thuốc:
                    </span>{" "}
                    {e?.loaiThuoc ?? "--"}
                  </Row>
                </Col>{" "}
                {e?.viTriMat != null && (
                  <Col span={8}>
                    <Row>
                      <span style={{fontWeight: "600", marginRight: 4}}>
                        Vị trí mắt:
                      </span>{" "}
                      {renderViTriMat(e?.viTriMat)}
                    </Row>
                  </Col>
                )}
                {e?.nguoiTra && (
                  <Col span={8}>
                    <Row>
                      <span style={{fontWeight: "600", marginRight: 4}}>
                        Người tra:
                      </span>{" "}
                      {e?.nguoiTra}
                    </Row>
                  </Col>
                )}
                {e?.ghiChu && (
                  <Col span={8}>
                    <Row>
                      <span style={{fontWeight: "600", marginRight: 4}}>
                        Ghi chú:
                      </span>{" "}
                      {e?.ghiChu}
                    </Row>
                  </Col>
                )}
              </Row>
            ))}
          </Row>
        </div>
      )}
    </Fragment>
  );
};

export default NurseExamPrintOut;
